<template>
  <label class="WSwitch">
    <span class="left">
      <slot name="left" />
    </span>

    <SwitchRoot class="SwitchRoot" :checked="switchState" @update:checked="handleChange">
      <SwitchThumb class="SwitchThumb" />
    </SwitchRoot>

    <span class="right">
      <slot name="right" />
    </span>
  </label>
</template>

<script lang="ts">
  // @ts-ignore
  import { SwitchRoot, SwitchThumb } from 'radix-vue';

  export default {
    name: 'WSwitch',
    emits: ['change', 'update:modelValue'],
    components: { SwitchRoot, SwitchThumb },

    props: {
      modelValue: Boolean,
      disabled: Boolean,
    },

    data() {
      return {
        switchState: this.modelValue || false,
      };
    },

    watch: {
      modelValue(newValue) {
        this.switchState = newValue;
      },
    },

    methods: {
      handleChange(value: boolean) {
        this.switchState = value;
        this.$emit('change', value);
        this.$emit('update:modelValue', value);
      },
    },
  };
</script>

<style lang="scss">
  @import '@/assets/styles/variables';

  .WSwitch {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;

    .left,
    .right {
      font-size: 1rem;
      font-weight: 500;
    }

    $transition: all ease-in-out 0.1s;

    .SwitchRoot {
      height: 1rem;
      width: 1.5rem;
      position: relative;
      border-radius: 2rem;
      background-color: $neutral-gray;
      padding: 2px;
      display: flex;
      transition: $transition;

      &[data-state='checked'] {
        background-color: $primary-main;
      }
    }

    .SwitchThumb {
      height: 100%;
      aspect-ratio: 1;
      border-radius: 100%;
      background-color: $input-border;
      transition: $transition;
      transform: translateX(0);

      &[data-state='checked'] {
        background-color: $white;
        transform: translateX(calc(100% - 4px));
      }
    }
  }
</style>
